<template>
  <v-btn @click="toggleValidatedView" :color="color" flat>
    <v-icon>history</v-icon>
    <span class="ml-2">Históricos</span>
  </v-btn>
</template>

<script>
import { mapState } from "vuex";

/**
 * A button to go to the validated items view.
 */
export default {
  data: () => ({
    validatedRouteName: "classifier/predictions/validated"
  }),
  computed: {
    ...mapState(["currentClassification"]),
    color() {
      switch (this.$route.name) {
        case this.validatedRouteName:
          return "blue";
        default:
          return "black";
      }
    }
  },
  methods: {
    toggleValidatedView() {
      if (this.$route.name === this.validatedRouteName) {
        this.$router.push({ name: "classifier/predictions/items" });
      } else {
        this.$router.push({ name: "classifier/predictions/validated" });
      }
    }
  }
};
</script>